const COMPLETE_STATUSES = new Set(["done", "warning", "skipped"]);

export function calculateRunProgress(run = {}) {
  const steps = Array.isArray(run.steps) ? run.steps : [];
  const done = steps.filter((step) => COMPLETE_STATUSES.has(step.status)).length;
  const total = steps.length;
  const active = steps.find((step) => step.status === "running");
  return {
    done,
    total,
    active,
    pct: run.status === "completed" ? 100 : total ? Math.round((done / total) * 100) : 0,
  };
}

export function getExecutionReportRunId(run = {}) {
  return run.backend_run_id || run.id;
}

export function getExecutionReportPath(run = {}) {
  const runId = getExecutionReportRunId(run);
  return runId ? `/runs/${runId}?tab=report` : "/runs?tab=report";
}

export function shouldShowGeneratedOutput(run = {}) {
  return run.status === "completed";
}

export function getVisibleReviewDeliverables(run = {}, deliverables = []) {
  return shouldShowGeneratedOutput(run) ? deliverables : [];
}
